"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatentIMSchema = exports.PatentSchema = exports.BasePatentSchema = exports.PatentOwnerSchema = void 0;
const zod_1 = require("zod");
const license_schema_1 = require("./license-schema");
const case_1 = require("./case");
const patent_enums_1 = require("../enums/patent-enums");
exports.PatentOwnerSchema = zod_1.z.nativeEnum(patent_enums_1.PatentOwner);
// Note: Creating a base patent schema without the case relationship such that we don't run into circular dependency issues
// What was removed: case: z.lazy(() => CaseSchema),
exports.BasePatentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    patentType: patent_enums_1.PatentTypeSchema,
    status: patent_enums_1.PatentStatusSchema.default(patent_enums_1.PatentStatus.FILED),
    caseId: zod_1.z.string(),
    description: zod_1.z.string().nullish(),
    ownedBy: exports.PatentOwnerSchema.nullish(),
    priorityDate: zod_1.z.coerce.date().nullish(),
    filingDate: zod_1.z.coerce.date().nullish(),
    internationalPublicationDate: zod_1.z.coerce.date().nullish(),
    grantDate: zod_1.z.coerce.date().nullish(),
    expiryDate: zod_1.z.coerce.date().nullish(),
    renewalDueDate: zod_1.z.coerce.date().nullish(),
    applicationNumber: zod_1.z.string().nullish(),
    publicationNumber: zod_1.z.string().nullish(),
    territory: zod_1.z.string().nullish(),
    territoryCode: zod_1.z.string().nullish(),
    createdAt: zod_1.z.coerce.date().default(new Date()),
    updatedAt: zod_1.z.coerce.date(),
});
exports.PatentSchema = exports.BasePatentSchema.extend({
    case: zod_1.z.lazy(() => case_1.BaseCaseSchema),
    licenses: zod_1.z.array(zod_1.z.lazy(() => license_schema_1.BaseLicenseSchema)),
});
exports.PatentIMSchema = exports.BasePatentSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
